import { TITLE } from 'components/common/ArrangementGroup/HeadMeta/translations/constants';

export const arrangementGroupHeadMetaCommonLocale = {
  [TITLE]: 'Edible Arrangements',
};
